/**
 *
 * Dashboard
 *
 */

import "../index.less"
import "./index.less"

import { Button, Empty, Spin, Modal, Input, Row } from "antd"
const { TextArea } = Input
import {
  getItem,
  LOCAL_AMBASSADOR_ID,
  LOCAL_DASHBOARD_BIRTHDAY_CHECK,
  LOCAL_USER_EMAIL,
  SHOWED_FEEDBACK_SURVEY,
  LOCAL_COMPANY_NAME,
  LOCAL_ACTIVE_ROL_NAME,
  isLeader,
  isModuleBySlug,
  LOCAL_COMPANY_HUBSPOT,
  LOCAL_COMPANY_COUNTRY,
  LOCAL_ONBOARDING,
  LOCAL_PDA_IA_ENABLED,
  LOCAL_NEW_PDA_IA_NOTIFICATION,
  LOCAL_USER_ID,
} from "../../../utils/storage"
import { initializeSurvicateVisitor } from "../../../utils/survicate"
import React, { Fragment } from "react"
import {
  getDashboardWatcher,
  getProfileAmbassadorWatcher,
  getTaskWatcher,
  submitFeedbackSurvey,
  dismissFeedbackSurvey,
} from "./actions"
import {
  makeSelectDashboardData,
  makeSelectIsLoadingProfile,
  makeSelectLoadingDashboard,
  makeSelectPendingSurveys,
  makeSelectProfileAmbassador,
} from "./selectors"

import ActionPlanCard from "components/ActionPlanCard"
import CardBirthDay from "components/CardBirthDay"
import CardWidget from "components/CardWidget"
import { Helmet } from "react-helmet"
import Layout from "components/Layout"
import ModalActionPlanCreate from "components/ModalActionPlanCreate"
import Onboarding from "components/Onboarding"
import PendingSurveys from "components/PendingSurveys"
import PropTypes from "prop-types"
import TaskCard from "components/TaskCard"
import { TransitionGroup } from "react-transition-group"
import UserList from "components/UserList"
import WidgetProgress from "components/WidgetProgress"
import WidgetResponseRate from "components/WidgetResponseRate"
import WidgetResumen from "components/WidgetResumen"
import { compose } from "redux"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import emptyStateActionPlans from "images/empty-state-action-plans.svg"
import emptyStateDashboard from "images/emptyStateDashboard.svg"
import { get } from "lodash"
import iconActivity from "images/icon-activity.svg"
import iconBars from "images/icon-bars.svg"
import iconTarget from "images/icon-target.svg"
import injectReducer from "utils/injectReducer"
import injectSaga from "utils/injectSaga"
import reducer from "./reducer"
import saga from "./saga"
import { woopraTrack } from "../../../utils/woopra/woopraTracker"
import { ACTION_PLANS } from "../../../utils/constants"
import { loadTexts, sanitize } from "../../../utils/i18n"
import Select from "react-select/lib/Select"
import DashboardSuggestionsIA from "components/DashboardSuggestionsIA"
import {  getDivisionsForAmbassadorDashboard } from "services/actionPlans"
import ModalPdaIaNotification from "../../../components/ModalPdaIaNotification"

/* eslint-disable react/prefer-stateless-function */
export class Dashboard extends React.Component {
  intl = loadTexts("dashboard")
  timeout;
  state = {
    modalActionPlanCreate: false,
    can_create_action_plan: false,
    measuresModalCreate: [],  
    surveyStep: 1,
    surveyVisible: false,
    surveyResponse: { score: 0, comments: "" },
    result_dimensions_ia: [],
    loading_dimensions_ia: false,
    dashboardSuggestionsIAKey: 0,
    loading_divisions_ia: false,
    isModalVisible: true,
  }
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    

    this.props.getProfileAmbassador()
    this.props.getDashboard()
    this.getDivisions()

    initializeSurvicateVisitor({
      user_id: LOCAL_USER_ID(),
      email: LOCAL_USER_EMAIL(),
      stage: process.env.APP_ENV,
      company: LOCAL_COMPANY_NAME(),
      role: LOCAL_ACTIVE_ROL_NAME(),
      hubspot: LOCAL_COMPANY_HUBSPOT(),
      user_country: LOCAL_COMPANY_COUNTRY(),
    })
  }
  componentWillUnmount() {
    if(this.timeout){
      clearTimeout(this.timeout);
    }

  }
  emptyState = () => {
    const { dashboard, loading_dashboard } = this.props
    const content = (
      <Empty
        style={{ color: "#828282", maxWidth: 500, margin: "50px auto" }}
        image={null}
        imageStyle={{ display: "none" }}
        description={
          <Fragment>
            <div>
              <img src={emptyStateDashboard} />
            </div>
            <span style={{ margin: "20px auto", display: "block" }}>
              <p>{sanitize(this.intl.generalView.emptyState.noInformation)}</p>
            </span>
            <p>{sanitize(this.intl.generalView.emptyState.extraInfo)}</p>
            <p>{sanitize(this.intl.generalView.emptyState.notificationInfo)}</p>
          </Fragment>
        }
      />
    )
    let type = 0
    let active = false
    // get(dashboard, 'measure_with_measure_metrics', []).length === 0 && get(dashboard, 'team', []).length === 0
    if (
      !loading_dashboard &&
      get(dashboard, "measure_with_measure_metrics", []).length === 0
    ) {
      type = 2
      active = true
    }
    if (
      !loading_dashboard &&
      get(dashboard, "measure_with_measure_metrics", []).length === 0 &&
      get(dashboard, "team", []).length === 0
    ) {
      type = 1
      active = true
    }
    return {
      active,
      type, // null,
      content,
    }
  }
  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }
  renderWidgetResponse = (division, measure) => {
    let data
    let climate_or_engagement =
      division.metrics_division_with_engagement.metrics_climate
    if (!climate_or_engagement) {
      climate_or_engagement =
        division.metrics_division_with_engagement.metrics_engagement

      data = {
        employees: climate_or_engagement.employees_engagement,
        recipients: climate_or_engagement.recipients_engagement,
        rate: {
          rate: climate_or_engagement.rate_engagement?.rate,
          rate_color: climate_or_engagement.rate_engagement?.rate_color,
          rate_visible: climate_or_engagement.rate_engagement?.rate_visible,
        },
        rate_variation: climate_or_engagement.rate_variation,
        rate_previous: climate_or_engagement.rate_previous
      }
    } else {
      data = {
        employees: climate_or_engagement.employees_division,
        recipients: climate_or_engagement.recipients_division,
        rate: {
          rate: climate_or_engagement.rate_division.rate,
          rate_color: climate_or_engagement.rate_division.rate_color,
          rate_visible: climate_or_engagement.rate_division.rate_visible,
        },
        rate_variation: climate_or_engagement.rate_variation,
        rate_previous: climate_or_engagement.rate_previous
      }
    }

    return (
      <WidgetResponseRate
        title={
          measure.survey_type === 2 ? (
            <b>{this.intl.responseRateWidget.responseRate}</b>
          ) : (
            <span style={{ fontWeight: "normal" }}>
              <b> {this.intl.responseRateWidget.responseRate}:</b>{" "}
              {division.division_name}
            </span>
          )
        }
        isLoading={false}
        dataRate={measure}
        data={data}
      />
    )
  }
  changeSurveyStep = (step) => {
    this.setState({ ...this.state, surveyStep: step })
  }
  saveSurveyScore = (score) => {
    let surveyResponse = this.state.surveyResponse
    surveyResponse.score = score
    this.setState({ ...this.state, surveyResponse })
    this.changeSurveyStep(2)
  }
  saveSurveyComments = (comments) => {
    let surveyResponse = this.state.surveyResponse
    surveyResponse.comments = comments
    this.setState({ ...this.state, surveyResponse })
    this.changeSurveyStep(3)
  }
  handleSurveyCommentsChange = (e) => {
    let surveyResponse = this.state.surveyResponse
    surveyResponse.comments = e.target.value
    this.setState({ ...this.state, surveyResponse })
  }
  handleSurveyCommentsCancel = () => {
    if (this.state.surveyStep != 3) {
      this.props.dismissFeedbackSurvey()
    }
    localStorage.setItem(
      SHOWED_FEEDBACK_SURVEY,
      !(localStorage.getItem(SHOWED_FEEDBACK_SURVEY) === "true")
    ),
      this.setState({ ...this.state, surveyVisible: false })
  }

  getDivisions = async () => {
    try {
      this.setState({   loading_dimensions_ia: false })
      const divisionsIa = await getDivisionsForAmbassadorDashboard({
        id_ambassador: LOCAL_AMBASSADOR_ID()
      });
      if (divisionsIa.status == 200) {
        this.setState({
          loading_dimensions_ia: true,
          result_dimensions_ia: divisionsIa.data.data.result
        })
       this.setState({dashboardSuggestionsIAKey: this.state.dashboardSuggestionsIAKey + 1})


      }

    } catch (error) {
      console.error("Error al obtener getDivisions:", error);
    }
  }
  setVisible = (visible) => {
    this.setState({ isModalVisible: visible });
  }
  render() {
    const {
      loading_profile_ambassador,
      profile_ambassador,
      dashboard,
      loading_dashboard,
      pending_surveys,
    } = this.props
    const { modalActionPlanCreate, measuresModalCreate, result_dimensions_ia,dashboardSuggestionsIAKey,loading_dimensions_ia } = this.state

    if (loading_profile_ambassador || loading_dashboard) {
      return (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )
    }
    const isActionPlans = isModuleBySlug(ACTION_PLANS)
    const isConditionMet =   LOCAL_ONBOARDING() && LOCAL_ONBOARDING() != "false" && JSON.parse(LOCAL_ONBOARDING()).some(item => 
      item.step > 5
    );
    return (
      <Layout>
         { (LOCAL_ONBOARDING() == "false" || isConditionMet ) && LOCAL_PDA_IA_ENABLED() && LOCAL_NEW_PDA_IA_NOTIFICATION() &&
        <ModalPdaIaNotification visible={this.state.isModalVisible} setVisible={this.setVisible} />
    }
    
        <Onboarding section="dashboard" />
        <Helmet>
          <title>Dashboard</title>
          <meta name="description" content="Description of HomePage" />
        </Helmet>
        <Modal
          centered
          visible={this.state.surveyVisible}
          footer={null}
          width={620}
          onCancel={this.handleSurveyCommentsCancel}>
          {this.state.surveyStep == 1 && (
            <>
              <div className="survey-feedback">
                <div className="title">
                  ¿Qué tan satisfecho te encuentras con el producto?*
                </div>
                <div className="container-button">
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(0)}>
                    0
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(1)}>
                    1
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(2)}>
                    2
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(3)}>
                    3
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(4)}>
                    4
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(5)}>
                    5
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(6)}>
                    6
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(7)}>
                    7
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(8)}>
                    8
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(9)}>
                    9
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(10)}>
                    10
                  </div>
                </div>
              </div>
            </>
          )}
          {this.state.surveyStep == 2 && (
            <>
              <div className="survey-feedback">
                <div className="title">¿Qué podríamos hacer para mejorar?</div>
                <TextArea
                  rows={3}
                  placeholder="Nos encantaría escuchar tus sugerencias..."
                  onChange={this.handleSurveyCommentsChange}
                />
                <br />
                <br />
                <Row justify="space-between">
                  <Button width={100} onClick={() => this.changeSurveyStep(1)}>
                    {" "}
                    &lt;&nbsp;Anterior
                  </Button>
                  <Button
                    width={100}
                    type="primary"
                    onClick={() => {
                      this.props.submitFeedbackSurvey(this.state.surveyResponse)
                      this.changeSurveyStep(3)
                    }}>
                    {" "}
                    &nbsp;&nbsp;&nbsp;Enviar&nbsp;&nbsp;&nbsp;{" "}
                  </Button>
                </Row>
              </div>
            </>
          )}
          {this.state.surveyStep == 3 && (
            <>
              <div className="survey-feedback">
                <br></br>
                <div
                  className="title"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    paddingLeft: "25px",
                  }}>
                  ¡Gracias por el feedback 💙!
                </div>
              </div>
            </>
          )}
        </Modal>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "12px 2rem 32px",
          }}
          className="Dashboard DashboardAmbassador">
          <div
            className="Dashboard-columns"
            style={{
              gridTemplateColumns: this.emptyState().type === 1 ? "auto" : null,
            }}>
            <div className="Dashboard-columns-left">
              <div className="Dashboard-columns-left-header">
                <div className="Dashboard-columns-left-header-block">
                  <h1>
                    {this.intl.generalView.greeting}{" "}
                    {get(profile_ambassador, "ambassador.first_name", "")}! 👋🏼{" "}
                  </h1>
                  <p>{this.intl.generalView.description}</p>
                </div>
                { ((result_dimensions_ia.divisions && result_dimensions_ia.divisions.length > 0) && loading_dimensions_ia) && LOCAL_PDA_IA_ENABLED() && (
                  <DashboardSuggestionsIA   key={dashboardSuggestionsIAKey} 
                  dashboardSuggestionsIAKey={dashboardSuggestionsIAKey}
                  result_dimensions_ia={result_dimensions_ia}  
                  setStateFrom={this.setStateFrom}
                  onCreatePlan={() => {
                    this.getDivisions()
                  }}
                  />
                )}
                {!loading_dimensions_ia  && LOCAL_PDA_IA_ENABLED() &&
                 <div className="loadingSpin">
                 <Spin size="large" />
                 </div>
                }
                {pending_surveys.length > 0 && (
                  <PendingSurveys surveys={pending_surveys} />
                )}
                {get(dashboard, "team", [])
                  .filter(
                    (e) =>
                      e.date_birth_2 === true &&
                      !JSON.parse(LOCAL_DASHBOARD_BIRTHDAY_CHECK()).includes(
                        e.id_employee
                      )
                  )
                  .map((cb, ci) => (
                    <CardBirthDay
                      key={`card-birthday-${ci}`}
                      data={{
                        avatar: cb.profile_picture,
                        id: cb.id_employee,
                        name: `${cb.first_name} ${cb.last_name}`,
                      }}
                    />
                  ))}
              </div>
              {this.emptyState().active ? (
                this.emptyState().content
              ) : (
                <Fragment>
                  <div className="Dashboard-columns-left-content">
                    <div className="Dashboard-columns-left-content-block">
                      <div className="Dashboard-columns-left-content-block-title">
                        <img src={iconActivity} />
                        {this.intl.generalView.generalActivity}
                      </div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3, minmax(auto, 341px))",
                          gridGap: 15,
                        }}>
                        <WidgetProgress
                          title={this.intl.generalView.actionPlan}
                          rate={parseInt(
                            get(dashboard, "percent_action_plan", 0)
                          )}
                          count={get(dashboard, "count_action_plans", 0)}
                          rate_visible={get(
                            dashboard,
                            "percent_action_plan",
                            "0%"
                          )}
                          color="#5682F2"
                        />
                        <WidgetProgress
                          title={this.intl.generalView.tasks}
                          rate={parseInt(get(dashboard, "percent_task", 0))}
                          count={get(dashboard, "count_tasks", 0)}
                          rate_visible={get(dashboard, "percent_task", "0%")}
                          color="#56CCF2"
                        />
                      </div>
                    </div>
                    <div className="Dashboard-columns-left-content-block">
                      <div className="Dashboard-columns-left-content-block-title">
                        <img src={iconBars} />
                        {this.intl.generalView.results}
                      </div>
                      <div style={{ display: "grid", gridGap: 20 }}>
                        {get(dashboard, "measure_with_measure_metrics", []).map(
                          (measure, si) => (
                            <div
                              key={si}
                              style={{ display: "grid", gridGap: 15 }}>
                              <h3>{measure.name}</h3>
                              {get(measure, "metrics_divisions", []).map(
                                (division, mi) => (
                                  <div
                                    className="Dashboard-columns-left-content-block-widgets"
                                    key={`metrics-divisions-${mi}`}>
                                    {[5].includes(
                                      get(measure, "id_measure_status", 0)
                                    ) &&
                                      division.metrics_division_with_engagement
                                        .metrics_climate && (
                                        <div
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            if (
                                              measure.survey_type !== 2 ||
                                              isLeader() == true
                                            ) {
                                              this.props.history.push(
                                                `/reports/measure/${measure.survey_type}/${measure.id_measure}?id_division=${division.id_division}`
                                              )
                                            }
                                          }}>
                                          <WidgetResumen
                                            className="WidgetResumenComponent boxShadow"
                                            title={
                                              measure.survey_type === 2 ? (
                                                <b>
                                                  {measure.metric_total_label ||
                                                    "Liderazgo"}
                                                </b>
                                              ) : (
                                                <span
                                                  style={{
                                                    fontWeight: "normal",
                                                  }}>
                                                  <b>
                                                    {measure.metric_total_label ||
                                                      "Clima laboral"}
                                                    :
                                                  </b>{" "}
                                                  {division.division_name}
                                                </span>
                                              )
                                            }
                                            isLoading={false}
                                            data={{
                                              employees:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_climate
                                                  .employees_division,
                                              value_visible:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_climate
                                                  .value_visible_division,
                                              color:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_climate
                                                  .color_division,
                                              percent:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_climate
                                                  .value_division,
                                              value_org:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_climate.value_org,
                                              calculate_comparative: {
                                                show:
                                                  division
                                                    .metrics_division_with_engagement
                                                    .metrics_climate
                                                    .variation_division != "",
                                                value: `${division.metrics_division_with_engagement.metrics_climate.variation_division}%`,
                                                level: !(
                                                  division
                                                    .metrics_division_with_engagement
                                                    .metrics_climate
                                                    .variation_division < 0
                                                ),
                                              },
                                            }}
                                          />
                                        </div>
                                      )}

                                    {[5].includes(
                                      get(measure, "id_measure_status", 0)
                                    ) &&
                                      division.metrics_division_with_engagement
                                        .metrics_engagement && (
                                        <div
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            if (
                                              measure.survey_type !== 2 ||
                                              isLeader() == true
                                            ) {
                                              this.props.history.push(
                                                `/reports/measure/${measure.survey_type}/${measure.id_measure}?id_division=${division.id_division}`
                                              )
                                            }
                                          }}>
                                          <WidgetResumen
                                            className="WidgetResumenComponent boxShadow"
                                            title={
                                              <span
                                                style={{
                                                  fontWeight: "normal",
                                                }}>
                                                <b> Engagement:</b>{" "}
                                                {division.division_name}
                                              </span>
                                            }
                                            isLoading={false}
                                            isEngagement
                                            data={{
                                              employees:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_engagement
                                                  .employees_engagement,
                                              percent:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_engagement
                                                  .value_engagement,
                                              engagement_org:
                                                measure.value_org_engagement || 0,
                                              value_org:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_engagement.value_org,
                                              value_visible:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_engagement
                                                  .value_visible_engagement,
                                              color:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_engagement
                                                  .color_engagement,
                                              calculate_comparative:
                                                division
                                                  .metrics_division_with_engagement
                                                  .metrics_engagement
                                                  .calculate_comparative_engagement,
                                            }}
                                          />
                                        </div>
                                      )}
                                    {this.renderWidgetResponse(
                                      division,
                                      measure
                                    )}
                                  </div>
                                )
                              )}
                            </div>
                          )
                        )}
                      </div>
                    </div>
                    {isActionPlans && (
                      <div className="Dashboard-columns-left-content-block">
                        <div className="Dashboard-columns-left-content-block-title">
                          <img src={iconTarget} />
                          {this.intl.generalView.actionPlan}
                        </div>
                        <div className="Dashboard-columns-left-content-block-plans">
                          {Array.isArray(profile_ambassador.plans) &&
                          profile_ambassador.plans.length > 0 ? (
                            <Fragment>
                              {profile_ambassador.plans.map((p, pi) => (
                                <ActionPlanCard
                                  item={p}
                                  key={`action-plan-${p.id_action_plan}`}
                                  onClick={() =>
                                    this.props.history.push(
                                      `/ambassador/${LOCAL_AMBASSADOR_ID()}#actionPlan`
                                    )
                                  }
                                  styleCard={{ cursor: "pointer" }}
                                />
                              ))}
                            </Fragment>
                          ) : (
                            <Empty
                              style={{ color: "#828282", marginTop: 10 }}
                              image={null}
                              imageStyle={{ display: "none" }}
                              description={
                                <Fragment>
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns: "auto auto",
                                      alignItems: "center",
                                    }}>
                                    <span
                                      style={{
                                        margin: "20px auto",
                                        display: "block",
                                      }}>
                                      <p>
                                        {sanitize(
                                          this.intl.generalView.emptyState
                                            .noActionPlan
                                        )}
                                      </p>
                                      <Button
                                        className="btn-orange"
                                        onClick={() => {
                                          woopraTrack("Crear plan de acción")
                                          this.setState({
                                            modalActionPlanCreate: true,
                                          })
                                        }}>
                                        &gt;{" "}
                                        {
                                          this.intl.generalView.actions
                                            .createActionPlan
                                        }
                                      </Button>
                                    </span>
                                    <img src={emptyStateActionPlans} />
                                  </div>
                                  <span
                                    className="ActionPlans-Empty-dashed"
                                    style={{ maxWidth: 450 }}>
                                    {sanitize(
                                      this.intl.generalView.emptyState
                                        .definition
                                    )}
                                  </span>
                                </Fragment>
                              }
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </Fragment>
              )}
            </div>
            <div
              className="Dashboard-columns-right"
              style={{ borderLeft: this.emptyState().type === 1 ? "0" : null }}>
              {get(dashboard, "active_tasks", []).length > 0 && (
                <CardWidget title={this.intl.generalView.nextTasks}>
                  <TransitionGroup className="todo-list">
                    {get(dashboard, "active_tasks", []).map((e, ei) => (
                      <TaskCard
                        key={`task-card-${e.id_task_schedule || e.id_task}`}
                        reload={() => {
                          this.props.getTask()
                        }}
                        status="#55c8ae"
                        data={{
                          name: e.name,
                          next: e.is_this_week,
                          date_format: e.date_transform,
                          id_task_schedule: e.id_task_schedule,
                          id_task: e.id_task,
                        }}
                      />
                    ))}
                  </TransitionGroup>
                </CardWidget>
              )}
              {get(dashboard, "team", []).length > 0 && (
                <UserList
                  hideLine
                  className="Dashboard-columns-right-team"
                  title={
                    <>
                      {this.intl.generalView.team}{" "}
                      <span>({get(dashboard, "team", []).length})</span>
                    </>
                  }
                  list={get(dashboard, "team", [])}
                />
              )}
            </div>
          </div>
        </div>
        <ModalActionPlanCreate
          visible={modalActionPlanCreate}
          modalActionPlanEditId={null}
          onCancel={() =>
            this.setState({
              modalActionPlanCreate: false,
              modalActionPlanEditId: null,
            })
          }
          canCreate={(value) => {
            this.setState({ can_create_action_plan: value })
          }}
          finish={() => {
            this.props.getProfileAmbassador()
            this.props.getDashboard()
            this.setState({
              modalActionPlanCreate: false,
              modalActionPlanEditId: null,
            })
          }}
          initialData={{
            selectedAmbassador: {
              id_ambassador: get(
                profile_ambassador,
                "ambassador.id_ambassador",
                null
              ),
            },
            measure:
              measuresModalCreate.length > 0
                ? measuresModalCreate[0].id_measure
                : null,
          }}
          setMeasures={(e) => this.setState({ measuresModalCreate: e })}
        />
      </Layout>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  loading_profile_ambassador: makeSelectIsLoadingProfile(),
  profile_ambassador: makeSelectProfileAmbassador(),
  loading_dashboard: makeSelectLoadingDashboard(),
  dashboard: makeSelectDashboardData(),
  pending_surveys: makeSelectPendingSurveys(),
})

function mapDispatchToProps(dispatch) {
  return {
    getProfileAmbassador: () => dispatch(getProfileAmbassadorWatcher()),
    getDashboard: () => dispatch(getDashboardWatcher()),
    getTask: () => dispatch(getTaskWatcher()),
    submitFeedbackSurvey: (params) => dispatch(submitFeedbackSurvey(params)),
    dismissFeedbackSurvey: (params) => dispatch(dismissFeedbackSurvey(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "dashboard-ambassador", reducer })
const withSaga = injectSaga({ key: "dashboard-ambassador", saga })

export default compose(withReducer, withSaga, withConnect)(Dashboard)
